'use client'

import { Typography, MediaImageStandard } from 'components/Contentful'
import { BLOCKS } from '@contentful/rich-text-types'
import { Card, CardActionArea } from '@achieve/ascend'
import NextLink from 'next/link'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { isExternal } from 'utils/conversions'
import { _get } from 'utils/shared'

export const CardLeadership = ({ content, testIdIndex }) => {
  const currentURL = useCurrentUrl()

  if (content === undefined || Object.keys(content).length === 0) return null
  const { cardTitleText, cardText, cardLink, cardImage, secondaryCardLink } = content || {}
  const execName = _get(cardTitleText, 'json.content[0].content[0].value')

  const bioHref = secondaryCardLink?.linkHref
  const href = bioHref || cardLink?.linkHref
  const isExternalLink = isExternal(href, currentURL)
  const linkProps = {
    component: bioHref ? NextLink : 'a',
    href,
    target: isExternalLink ? '_blank' : '_self',
    ...(isExternalLink && { rel: 'noreferrer nofollow' }),
    'aria-label': isExternalLink
      ? execName
        ? `${execName} - link opens in a new tab`
        : 'Link opens in a new tab'
      : execName
      ? `${execName} - read full bio`
      : 'Read full bio',
  }

  return (
    <Card
      className="w-[280px] h-[338px] relative p-0"
      data-testid={`leadership-card-${testIdIndex}`}
    >
      <CardActionArea
        {...linkProps}
        className="h-full w-full"
        data-testid={`leadership-card-link-${testIdIndex}`}
      >
        <MediaImageStandard content={cardImage} layout="fill" />
        <div
          className="w-full h-[63px] absolute bottom-0 flex flex-col justify-center items-center bg-white opacity-80 px-4 text-center"
          data-testid="leadership-card-footer"
        >
          <Typography
            content={cardTitleText}
            variantOverride={{ [BLOCKS.PARAGRAPH]: 'bodyLg' }}
            fontWeight="bold"
            data-testid={`leadership-card-title-${testIdIndex}`}
          />
          <Typography
            content={cardText}
            variantOverride={{ [BLOCKS.PARAGRAPH]: 'bodyXs' }}
            data-testid={`leadership-card-text-${testIdIndex}`}
          />
        </div>
      </CardActionArea>
    </Card>
  )
}
